import { queryTabbables, focusElement } from '@/mixins/focusMixin';

const keys = ['ArrowRight', 'ArrowLeft'];

export default {
  directives: {
    onArrowTab: {

      inserted: (el, binding, { context }) => {
        const temp = document.createElement('input');
        temp.type = 'hidden';
        document.body.appendChild(temp);
        const keyupListener = (event) => {
          if (!keys.includes(event.key)) {
            return;
          }
          const forms = [...document.forms];
          const elements = [];
          forms.forEach((item) => {
            elements.push(...item.querySelectorAll(queryTabbables));
          });
          let focusedIndex = elements.findIndex((item) => item === document.activeElement);
          if (event.key === 'ArrowRight') {
            if (elements.length - 1 === focusedIndex) {
              focusedIndex = -1;
            }
            focusedIndex += 1;
          }
          if (event.key === 'ArrowLeft') {
            if (focusedIndex <= 0) {
              focusedIndex = elements.length;
            }
            focusedIndex -= 1;
          }
          if (elements[focusedIndex]) {
            event.preventDefault();
            temp.click();
            focusElement(elements[focusedIndex]);
          }
        };
        window.document.addEventListener('keydown', keyupListener);
        context.$once(
          'hook:destroyed',
          () => {
            document.body.removeChild(temp);
            window.document.removeEventListener('keydown', keyupListener);
          },
        );
      },
    },
  },
};
